<script lang="ts">
  import { Button } from '@athena-lib/Button';
  import { Text } from '@athena-lib/Text';
  import { Close } from '@athena-lib/Icons';
  import { getCommonTranslations } from '@athena-lib/commonTranslationsContext';

  type LocalizationBannerProps = {
    countryImageSource: string;
    onContinue: () => void;
    onClose: () => void;
  };

  const { countryImageSource, onContinue, onClose }: LocalizationBannerProps = $props();
  const translations = getCommonTranslations();
</script>

<article
  class="flex flex-col text-wrap border bg-st-white p-6 drop-shadow-banner"
  aria-labelledby="banner-title"
  aria-describedby="banner-description"
>
  <div class="flex items-center justify-between gap-4">
    <div class="flex items-center gap-4">
      <img src={countryImageSource} alt="" aria-hidden={true} class="aspect-auto w-8" />
      <h3 id="banner-title" class="text-base font-black">
        {translations.orderFromOtherCountryLabel}
      </h3>
    </div>
    <button type="button" onclick={onClose} aria-label={translations.closeText}>
      <span aria-hidden={true}>
        <Close sizeClass="size-8" />
      </span>
    </button>
  </div>
  <Text id="banner-description" element="p" size="medium" class="mt-4 max-w-md text-pretty"
    >{translations.orderFromOtherCountryDescription}</Text
  >
  <Button onClick={onContinue} color="dark" class="mt-8">{translations.continue}</Button>
</article>
